// extracted by mini-css-extract-plugin
export default {"itemWrapper":"MediaUploadCard_itemWrapper__SGNpc","fileWrapper":"MediaUploadCard_fileWrapper__m3dPT"};